const actions = {
  LOGIN_BEGIN: 'LOGIN_BEGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERR: 'LOGIN_ERR',
  LOGIN_DATA: 'LOGIN_DATA',

  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERR: 'LOGOUT_ERR',

  RESET_BEGIN: 'RESET_BEGIN',
  RESET_SUCCESS: 'RESET_SUCCESS',
  RESET_ERR: 'RESET_ERR',

  FORGOT_BEGIN: 'FORGOT_BEGIN',
  FORGOT_SUCCESS: 'FORGOT_SUCCESS',
  FORGOT_ERR: 'FORGOT_ERR',

  REFRESH_BEGIN: 'REFRESH_BEGIN',
  REFRESH_SUCCESS: 'REFRESH_SUCCESS',
  REFRESH_ERR: 'REFRESH_ERR',

  loginBegin: () => {
    return {
      type: actions.LOGIN_BEGIN,
    };
  },

  loginSuccess: (data) => {
    return {
      type: actions.LOGIN_SUCCESS,
      data,
    };
  },

  loginData: (data) => {
    return {
      type: actions.LOGIN_DATA,
      data,
    };
  },

  loginErr: (err) => {
    return {
      type: actions.LOGIN_ERR,
      err,
    };
  },

  logoutBegin: () => {
    return {
      type: actions.LOGOUT_BEGIN,
    };
  },

  logoutSuccess: (data) => {
    return {
      type: actions.LOGOUT_SUCCESS,
      data,
    };
  },

  logoutErr: (err) => {
    return {
      type: actions.LOGOUT_ERR,
      err,
    };
  },

  resetBegin: () => {
    return {
      type: actions.RESET_BEGIN,
    };
  },

  resetSuccess: (data) => {
    return {
      type: actions.RESET_SUCCESS,
      data,
    };
  },

  resetErr: (err) => {
    return {
      type: actions.RESET_ERR,
      err,
    };
  },

  forgotErr: (err) => {
    return {
      type: actions.FORGOT_ERR,
      err,
    };
  },

  forgotBegin: () => {
    return {
      type: actions.FORGOT_BEGIN,
    };
  },

  forgotSuccess: (data) => {
    return {
      type: actions.FORGOT_SUCCESS,
      data,
    };
  },

  refreshErr: (err) => {
    return {
      type: actions.REFRESH_ERR,
      err,
    };
  },

  refreshBegin: () => {
    return {
      type: actions.REFRESH_BEGIN,
    };
  },

  refreshSuccess: (data) => {
    return {
      type: actions.REFRESH_SUCCESS,
      data,
    };
  },
};

export default actions;
